











import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import LockBackgroundMixin from '@/mixin/LockBackground'

@Component({
  mixins: [
    LockBackgroundMixin,
  ],
})
export default class Spinner extends Vue {
  @Prop({ default: true })
  overlay: boolean

  get _class() {
    return {
      'c-spinner__overlay': this.overlay,
      'c-spinner__overlay--not': !this.overlay,
    }
  }
}
